// extracted by mini-css-extract-plugin
module.exports = {"Nav":"Navigation_Nav__37L7n","link":"Navigation_link__1zATx","active":"Navigation_active__ylBVF","icon":"Navigation_icon__2foFT","title":"Navigation_title__SfSGD"};